export default __webpack_public_path__ + "static/media/backgound_space.b72dbcb3.jpg";